import { render, staticRenderFns } from "./HsabNotionalAccountTransactions.vue?vue&type=template&id=bc051100&scoped=true"
import script from "./HsabNotionalAccountTransactions.vue?vue&type=script&lang=ts"
export * from "./HsabNotionalAccountTransactions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc051100",
  null
  
)

export default component.exports